import { ZapCardTemplate } from "src/components/ZapCard";
import styles from "./AppsSection.module.css";
import { Text } from "@zapier/design-system";
type Props = {
  template: ZapCardTemplate;
};

export const AppsSection = ({ template }: Props) => {
  const apps = template.apps?.items;
  if (!apps?.length) {
    return null;
  }

  return (
    <section>
      <Text
        type="ParagraphHeader2"
        className={styles.sidebarSectionTitle}
        tag="h2"
      >
        Apps
      </Text>
      <ul className={styles.apps}>
        {apps.map((app) => (
          <li className={styles.app} key={app.slug}>
            <div className={styles.appIconContainer}>
              <img
                className={styles.appIcon}
                src={app.imageUrl}
                alt={`${app.name} icon`}
              />
            </div>
            <Text type="Body3">{app.name}</Text>
          </li>
        ))}
      </ul>
    </section>
  );
};
